/** Impl dos use cases de Certificado. @since G.5.8 */
import type { Page } from '@/domain/model/Page';
import type { Certificado, RevogarCertificadoCommand } from '@/domain/model/Certificado';
import type {
  CertificadoGateway, ListCertificadosParams,
} from '@/application/port/out/CertificadoGateway';
import type {
  ListCertificadosUseCase, ListCertificadosByAlunoUseCase, GetCertificadoUseCase,
  MarcarCertificadoBaixadoUseCase, RevogarCertificadoUseCase,
} from '@/application/port/in/CertificadoUseCase';

export class ListCertificados implements ListCertificadosUseCase {
  constructor(private readonly g: CertificadoGateway) {}
  execute(params: ListCertificadosParams): Promise<Page<Certificado>> { return this.g.list(params); }
}
export class ListCertificadosByAluno implements ListCertificadosByAlunoUseCase {
  constructor(private readonly g: CertificadoGateway) {}
  execute(alunoId: string): Promise<Certificado[]> { return this.g.listByAluno(alunoId); }
}
export class GetCertificado implements GetCertificadoUseCase {
  constructor(private readonly g: CertificadoGateway) {}
  execute(id: string): Promise<Certificado> { return this.g.get(id); }
}
export class MarcarCertificadoBaixado implements MarcarCertificadoBaixadoUseCase {
  constructor(private readonly g: CertificadoGateway) {}
  execute(id: string): Promise<Certificado> { return this.g.marcarBaixado(id); }
}
export class RevogarCertificado implements RevogarCertificadoUseCase {
  constructor(private readonly g: CertificadoGateway) {}
  execute(id: string, cmd: RevogarCertificadoCommand): Promise<Certificado> { return this.g.revogar(id, cmd); }
}
